module.exports = __webpack_public_path__ + "img/icon3.2003e7da.png";